module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/missouri-652d99011f7bebcd9f56bd7114744325.svg";